import { Base } from './base.model';

export class Strata extends Base {
  public strata: number;
  public area: number;
  public valuation: number;
}
